import React from "react";
import skillsData from "../data/skills";
import { languageIcons, technologyIcons, frameworkIcons } from "../data/skillIcons";

const Skills = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700 mb-7">
          Skills
        </h1>
        <div className="my-10 sm:text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>{skillsData.headings.languages}</span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="pl-2 py-2">
              <ul className="flex space-x-5 justify-evenly mt-3">
                {languageIcons.map((i) => (
                  <div className="sm:space-x-4" key={i.key}>
                    <img className={i.className} src={i.src} alt={i.alt} loading="lazy" decoding="async" />
                  </div>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="my-10 sm:text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>{skillsData.headings.subjects}</span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="pl-2 py-2">
              <ul className="sm:flex sm:justify-evenly mt-5">
                {skillsData.subjects.map((s) => (
                  <div className="flex space-x-2 sm:space-x-4" key={s}>
                    <li>
                      <i className="fa-solid fa-circle text-xs"></i>
                    </li>
                    <li>{s}</li>
                  </div>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="my-10 sm:text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>{skillsData.headings.technologies}</span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="pl-2 py-5">
              <ul className="sm:flex sm:justify-center sm:space-x-20 mt-3 break-words">
                {technologyIcons.filter((t) => skillsData.technologies.includes(t.key)).map((t) => (
                  <div className="sm:space-x-4 my-3" key={t.key}>
                    <img className={t.className} src={t.src} alt={t.alt} loading="lazy" decoding="async" />
                  </div>
                ))}
              </ul>
            </div>
            <div className="pl-2 sm:pt-3">
              <ul className="flex justify-between sm:justify-evenly">
                {frameworkIcons.filter((t) => skillsData.frameworks.includes(t.key)).map((t) => (
                  <div className="sm:space-x-4" key={t.key}>
                    <img className={t.className} src={t.src} alt={t.alt} loading="lazy" decoding="async" />
                  </div>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="my-10 sm:text-lg">
          <span className="flex space-x-7 justify-center text-xl font-bold bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
            <div className="flex justify-center items-center break-words">
              <div className="flex">
                <span>
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
                <span>{skillsData.headings.softSkills}</span>
                <span className="hidden sm:block">
                  <i className="fa-solid fa-arrows-to-dot px-2"></i>
                </span>
              </div>
            </div>
          </span>
          <div className="">
            <div className="pl-2 py-2">
              <ul className="sm:flex sm:justify-evenly mt-5">
                {skillsData.softSkills.map((s) => (
                  <div className="flex space-x-2 sm:space-x-4" key={s}>
                    <li>
                      <i className="fa-solid fa-circle text-xs"></i>
                    </li>
                    <li>{s}</li>
                  </div>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
